// Shared connection-probe mechanics, lifted out of pos-app/ConnectionStatus.js
// so the native shell and the browser shell run identical logic instead of two
// drifting copies. No React here on purpose: the reducer and the ping are the
// parts worth testing directly, and both providers are thin wrappers over them.
//
// This module is the seam the offline sub-project attaches queueing to.

export const HEALTH_PATH = '/health';
export const DEFAULT_PING_INTERVAL_MS = 30000;
export const PING_TIMEOUT_MS = 5000;

export function navigatorOnline() {
    return typeof navigator === 'undefined' || navigator.onLine !== false;
}

export function initialConnectionState() {
    return { online: navigatorOnline(), reconnecting: false };
}

export function connectionReducer(state, action) {
    switch (action.type) {
        case 'NAVIGATOR_ONLINE':
            return state.online ? state : { ...state, online: true };
        case 'NAVIGATOR_OFFLINE':
            return { online: false, reconnecting: false };
        case 'PING_SUCCESS':
            return state.online && !state.reconnecting ? state : { online: true, reconnecting: false };
        case 'PING_FAILURE':
            return state.reconnecting ? state : { ...state, reconnecting: true };
        default:
            return state;
    }
}

// Never throws — a failed ping is a normal signal, not an error condition.
export async function pingHealth(api) {
    try {
        await api.get(HEALTH_PATH, { timeout: PING_TIMEOUT_MS });
        return true;
    } catch {
        return false;
    }
}
